import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../../constents';
import ComCurtainSingleMsgView from './ComCurtainSingleMsgView';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import ComCurtainSingleMsg from './ComCurtainSingleMsg';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import Button from '../../Button';
import { CiShare1 } from 'react-icons/ci';
import {
  setMessageCount,
  setMsgInboxCount,
} from '../../../redux/slices/communicationSlice';
import { useDispatch, useSelector } from 'react-redux';

function CommunicationCurtain({ close, setSelRecipentPopUp }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);
  const [reload, setReload] = useState(false);
  const [tampletList, setTampletList] = useState([]);
  const [singleMsgData, setSingleMsgData] = useState(false);
  const [selectedMsgId, setSelectedMsgId] = useState('');
  const [selectedMsgType, setSelectedMsgType] = useState(0);
  const [ComCurtainSingleMsgViewPopup, setComCurtainSingleMsgViewPopup] =
    useState(false);
  const [deleteMsgConfirmPopup, setDeleteMsgConfirmPopup] = useState(false);
  const [sucPrams, setSucPrams] = useState([]);
  const [msgId, setMsgId] = useState('');
  const [msgType, setMsgType] = useState('');
  const [unreadCheck, setUnreadCheck] = useState('0');
  const [flagCheck, setFlagCheck] = useState('0');
  const [flag, setFlag] = useState('0');

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/communication/Communication/messageList',
          {
            box: 'inbox', //inbox, sent, trash//  for communication curtain -> box ='inbox'
            userType: '', //Patient, clinic// for communication curtain -> userType =''
            filterMsgId: '', // ''=>all, 1->text, 2-Email(thread), 3->patient portal //
            loginUserId: user?.id,
            msgId: msgId ? msgId : '',
            msgType: msgType ? msgType : '',
            actionFrom: 'curtain', // 'curtain' only in case of curtain else ''
            curtainUnread: unreadCheck,
            curtainFlagged: flagCheck,
            // filter: unreadCheck === '1' || flagCheck === '1' ? '1' : '0',
          }
        );
        if (response?.status === 200) {
          setTampletList(response?.data?.msgListArr || []);
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    })();
  }, [user?.id, reload, msgId, msgType, unreadCheck, flagCheck]);

  useEffect(() => {
    const handleReadUnread = (id) => {
      setTampletList((prevList) => {
        return prevList.map((item) => {
          if (item.msgId === id) {
            return { ...item, unreadCl: '' };
          } else {
            return item;
          }
        });
      });
    };
    handleReadUnread(selectedMsgId);
  }, [selectedMsgId, setTampletList]);

  useEffect(() => {
    (async () => {
      try {
        if (selectedMsgId && selectedMsgType) {
          const response = await post(
            'api/communication/Communication/messageDetail',
            {
              msgId: selectedMsgId, // message Id
              type: selectedMsgType, // Inbox, sent, trash//
              loginUserId: user?.id,
              box: 'inbox',
            }
          );
          if (response?.status === 200) {
            setSingleMsgData(response?.data?.msgDetail);
            dispatch(setMessageCount(response?.data?.totalCnt || 0));
            dispatch(
              setMsgInboxCount({
                clinic: response?.data?.countCliUnreadMsg || 0,
                patient: response?.data?.countPatUnreadMsg || 0,
              })
            );
          }
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    })();
  }, [selectedMsgId, selectedMsgType, dispatch, user?.id, globalReload]);

  const handleShowSingleMsg = async (id, type, redFlag) => {
    setSelectedMsgId(id);
    setSelectedMsgType(type);
    setFlag(redFlag);
    setComCurtainSingleMsgViewPopup(true);
  };

  const handleDeleteSingleMsg = (msgId, type) => {
    setDeleteMsgConfirmPopup(true);
    setSucPrams([msgId, type]);
  };

  const handleDeleteMsgFromList = async (prams) => {
    try {
      setDeleteMsgConfirmPopup(false);
      const response = await post(
        'api/communication/Communication/deleteMessage',
        {
          msgId: prams[0], // message Id
          msgType: prams[1], // 1, 2, 3
          fromFolder: 'inbox', // inbox, sent, trash
          loginUserId: user?.id,
        }
      );
      if (response?.status === 200) {
        if (response?.data?.statusCode === '1') {
          setUiMessage('suc', response?.data?.msg);
          setComCurtainSingleMsgViewPopup(false);
          setReload(!reload);
        } else {
          setUiMessage('err', response?.data?.msg);
        }
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  const handleFlagChange = async (msgId, type, flag, isFromInside = false) => {
    try {
      const response = await post(
        'api/communication/Communication/setMarkFlag',
        {
          msgId: msgId,
          type: type, //1->sms, 2->email thread, 3->intra msg
          flag: flag, // 1->mark red flag
          loginUserId: user?.id,
        }
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Flag has been updated successfully.');
        if (!isFromInside) setReload(!reload);
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  return (
    <div className="modalBackground">
      <div
        className="left com-curtn-mn-cntnr slide-down"
        style={{ right: 'unset', top: 'unset' }}
        id=""
      >
        <div className="flex-sec com-curtn-hdr justify-between item-center">
          <div>
            <span className="com-curtn-clse">Communication:</span>
            <span style={{ marginLeft: '20px' }}>
              <span className="">
                <input
                  type="checkbox"
                  className="clear-top5"
                  onChange={() =>
                    unreadCheck === '0'
                      ? setUnreadCheck('1')
                      : setUnreadCheck('0')
                  }
                  value={unreadCheck}
                  checked={unreadCheck === '1' ? true : false}
                />
              </span>
              <span style={{ marginLeft: '4px' }}>Unread</span>
            </span>
            <span style={{ marginLeft: '20px' }}>
              <span className="">
                <input
                  type="checkbox"
                  className="clear-top5"
                  onChange={() =>
                    flagCheck === '0' ? setFlagCheck('1') : setFlagCheck('0')
                  }
                  value={flagCheck}
                  checked={flagCheck === '1' ? true : false}
                />
              </span>
              <span style={{ marginLeft: '4px' }}>Flagged</span>
            </span>
          </div>
          <Button
            variant="outline"
            className="right"
            onClick={() => {
              setSelRecipentPopUp();
              close();
            }}
          >
            <span className="flex-sec item-center gap10">
              New
              <CiShare1 />
            </span>
          </Button>
        </div>
        <div className="left com-curtn-bdy-incmng ">
          {(() => {
            if (tampletList && tampletList.length > 0) {
              return tampletList.map((item, i) => {
                const altClas = i % 2 !== 0 ? 'alt-rw' : '';
                return (
                  <ComCurtainSingleMsg
                    key={i}
                    altClas={altClas}
                    item={item}
                    selectedMsgId={selectedMsgId}
                    handleShowSingleMsg={handleShowSingleMsg}
                    handleDeleteSingleMsg={handleDeleteSingleMsg}
                    handleFlagChange={handleFlagChange}
                    close={close}
                  />
                );
              });
            } else {
              return <span className="no-appoinmnts-here">No message!</span>;
            }
          })()}
        </div>
        <div
          className="flex-sec justify-between width100 item-center"
          style={{ padding: '5px 10px' }}
        >
          <span className="crtn-all-msgs " onClick={close}>
            <Link to={`${DEFAULT_LOCAL_PATH}/communication`}>
              See all messages
            </Link>
          </span>
          <Button variant="deafult" className="clear-right" onClick={close}>
            Close
          </Button>
        </div>
      </div>
      {ComCurtainSingleMsgViewPopup && (
        <ComCurtainSingleMsgView
          closeMainComCurtain={close}
          close={() => setComCurtainSingleMsgViewPopup(false)}
          key={Math.random()}
          data={singleMsgData}
          handleReload={() => setReload(!reload)}
          setSelRecipentPopUp={setSelRecipentPopUp}
          setMsgId={setMsgId}
          setMsgType={setMsgType}
          handleDeleteSingleMsg={handleDeleteSingleMsg}
          handleFlagChange={handleFlagChange}
          flag={flag}
        />
      )}
      {deleteMsgConfirmPopup && (
        <div
          className="left com-curtn-mn-cntnr"
          style={{ right: 'unset', top: 'unset' }}
          id=""
        >
          <ConfirmDialog
            title={''}
            bodytext={`Do you want to delete this message thread?`}
            closeDialog={() => setDeleteMsgConfirmPopup(false)}
            successDialog={handleDeleteMsgFromList}
            sucPrams={sucPrams}
            comCurtain={true}
          />
        </div>
      )}
    </div>
  );
}

export default CommunicationCurtain;
